//import { css } from "@emotion/react"
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";

export type ProductBrowserGridItemItemNoProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserGridItemItemNo: React.FC<
	ProductBrowserGridItemItemNoProps
> = (props) => {
	const product = props.product;

	return <div className="field py-1 text-xs"># {product.InventoryNo}</div>;
};
